// Stack-slide frame effect - port lại đúng cơ chế "fullpage-vertical-parallax"
// của kit.js (framework thật của aiononline.plaync.com, xem kit.css bản
// v2.6.20): mỗi frame nằm CHỒNG lên nhau trong #frameTrack (position:
// absolute, cùng chiếm trọn track).
//   Trạng thái NGHỈ (không animate):
//     i <  current -> translate3d(0,-50%,0), z-index 2  (đã trôi qua)
//     i == current -> translate3d(0,  0%,0), z-index 4  (đang hiển thị)
//     i >  current -> translate3d(0, 50%,0), z-index 2  (đang chờ)
//   Khi CHUYỂN frame (đây là điểm khác biệt so với công thức "N - |i-current|"
//   thông thường): frame ĐANG active (sắp thành frame cũ) GIỮ NGUYÊN z-index
//   cao nhất (4) và trượt hẳn ra ngoài (-100%/+100% theo hướng chuyển), còn
//   frame SẮP active chỉ trượt từ ±50% về 0% với z-index thấp hơn (3). Nhờ
//   vậy frame cũ luôn "đè" ở trên trong lúc trượt ra, để lộ dần frame mới ở
//   phần nó đã nhường lại - đúng cảm giác "frame sau trồi lên từ phía dưới,
//   bị frame trước che dần cho tới khi frame trước trượt hẳn ra khỏi màn
//   hình". Hết thời gian animate, JS đưa cả 2 frame về lại đúng trạng thái
//   nghỉ ở trên (ẩn sau lưng frame active mới nên không có gì lộ ra).
// #frameTrack nằm BÊN TRONG #MS__wrapper (thêm ở index.html.twig) để không
// đụng transform: scale() mà scaleRoot.js (libraryMainsite) áp cho
// #MS__wrapper.
//
// Mỗi section đã có height cố định riêng theo breakpoint (khai báo trong
// scss của từng section, vd #header/#news height:1300px, @include mobile
// height khác) - không cần JS đo/ép height, chỉ cần set position:absolute
// để chúng chồng lên nhau; % dịch chuyển tự tính theo đúng height riêng đó.

// Hiệu ứng stack-slide (hijack scroll) CHỈ áp cho PC. Trên mobile (dọc) người
// dùng cần cuộn dọc native bình thường -> KHÔNG hijack, để frame nằm theo luồng
// tài liệu và body tự cuộn. Điều kiện PC khớp đúng mixin @include pc của scss
// (webpack additionalData): (min-width: 769px) hoặc (orientation: landscape).
var MQ_PC = window.matchMedia("(min-width: 769px), (orientation: landscape)");

// Reload/back-forward có thể khiến trình duyệt tự khôi phục vị trí cuộn cũ
// (scroll restoration) TRƯỚC KHI script này kịp chạy - lúc đó overflow:hidden
// không xoá được scrollTop còn sót lại, làm frame active bị lệch so với phần
// đã cuộn thật. Chỉ cần khi hijack (PC); mobile giữ scroll restoration mặc định.
if (MQ_PC.matches && "scrollRestoration" in history) {
  history.scrollRestoration = "manual";
}

(function () {
  // Băng qua breakpoint PC <-> mobile đổi hẳn cơ chế cuộn (hijack vs native) nên
  // reload đúng 1 lần cho đơn giản, tránh phải gỡ/gắn lại toàn bộ listener + style.
  function onBreakpointChange() { window.location.reload(); }
  if (MQ_PC.addEventListener) {
    MQ_PC.addEventListener("change", onBreakpointChange);
  } else if (MQ_PC.addListener) {
    MQ_PC.addListener(onBreakpointChange); // Safari cũ
  }

  function init() {
    // Mobile (dọc): không hijack, để native scroll.
    if (!MQ_PC.matches) return;

    var track = document.getElementById("frameTrack");
    if (!track) return; // trang không dùng fullpage (vd subpage-news-list)

    var frames = Array.prototype.filter.call(track.children, function (el) {
      return el.tagName === "SECTION";
    });
    var N = frames.length;
    if (N < 2) return;

    var prefersReducedMotion = window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    var DURATION = 800;
    var WHEEL_THRESHOLD = 10;
    var SWIPE_THRESHOLD = 50;
    var RESIZE_DEBOUNCE = 150;
    var current = 0;
    var isAnimating = false;
    var resizeTimer = null;

    // Ép về đỉnh trang thật trước khi khoá overflow, phòng trường hợp trình
    // duyệt đã tự cuộn dở (Ctrl+F5, back/forward) trước khi script chạy tới.
    window.scrollTo(0, 0);

    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";

    track.style.position = "relative";
    track.style.overflow = "hidden";

    frames.forEach(function (f) {
      f.style.position = "absolute";
      f.style.top = "0";
      f.style.left = "0";
      f.style.width = "100%";
      f.style.willChange = "transform";
      f.style.transition = prefersReducedMotion
        ? "none"
        : "transform " + DURATION + "ms ease";
    });

    // Track không cao tự nhiên nữa (con đã position:absolute) -> lấy chiều
    // cao lớn nhất trong các frame để không frame nào bị cắt bởi overflow.
    function syncTrackHeight() {
      var maxHeight = frames.reduce(function (max, f) {
        return Math.max(max, f.offsetHeight);
      }, 0);
      track.style.height = maxHeight + "px";
    }

    // Đưa toàn bộ frame về đúng trạng thái nghỉ theo current hiện tại.
    function renderRest() {
      frames.forEach(function (f, i) {
        var y = i < current ? "-50%" : i > current ? "50%" : "0%";
        f.style.transform = "translate3d(0, " + y + ", 0)";
        f.style.zIndex = i === current ? 4 : 2;
        f.classList.toggle("is-active", i === current);
      });
    }

    function goTo(index) {
      index = Math.max(0, Math.min(N - 1, index));
      if (index === current || isAnimating) return;
      isAnimating = true;

      var oldIndex = current;
      var newIndex = index;
      var goingNext = newIndex > oldIndex;

      // Frame cũ: giữ z-index cao nhất, trượt hẳn ra ngoài theo hướng chuyển.
      frames[oldIndex].style.zIndex = 4;
      frames[oldIndex].style.transform = "translate3d(0, " + (goingNext ? "-100%" : "100%") + ", 0)";

      // Frame mới: trượt về giữa, z-index thấp hơn nên tạm thời bị frame cũ
      // che cho tới khi frame cũ trượt ra khỏi vùng nhìn.
      frames[newIndex].style.zIndex = 3;
      frames[newIndex].style.transform = "translate3d(0, 0, 0)";
      frames[newIndex].classList.add("is-active");
      frames[oldIndex].classList.remove("is-active");

      current = newIndex;

      window.setTimeout(function () {
        isAnimating = false;
        // Ẩn hẳn sau lưng frame active mới nên đưa về nghỉ không gây giật.
        var restore = frames[oldIndex].style.transition;
        frames.forEach(function (f) { f.style.transition = "none"; });
        renderRest();
        frames[oldIndex].offsetHeight; // ép reflow trước khi trả lại transition
        frames.forEach(function (f) { f.style.transition = restore; });
      }, prefersReducedMotion ? 0 : DURATION);
    }

    window.addEventListener("wheel", function (e) {
      if (isAnimating) { e.preventDefault(); return; }
      if (Math.abs(e.deltaY) < WHEEL_THRESHOLD) return;
      e.preventDefault();
      goTo(current + (e.deltaY > 0 ? 1 : -1));
    }, { passive: false });

    var touchStartY = 0;
    window.addEventListener("touchstart", function (e) {
      touchStartY = e.touches[0].clientY;
    }, { passive: true });
    window.addEventListener("touchmove", function (e) {
      if (isAnimating) e.preventDefault();
    }, { passive: false });
    window.addEventListener("touchend", function (e) {
      if (isAnimating) return;
      var delta = touchStartY - e.changedTouches[0].clientY;
      if (Math.abs(delta) < SWIPE_THRESHOLD) return;
      goTo(current + (delta > 0 ? 1 : -1));
    }, { passive: true });

    window.addEventListener("keydown", function (e) {
      var tag = (document.activeElement && document.activeElement.tagName) || "";
      if (["INPUT", "TEXTAREA", "SELECT"].indexOf(tag) !== -1) return;
      if (e.key === "ArrowDown" || e.key === "PageDown") {
        e.preventDefault();
        goTo(current + 1);
      } else if (e.key === "ArrowUp" || e.key === "PageUp") {
        e.preventDefault();
        goTo(current - 1);
      }
    });

    // Resize (kể cả băng qua breakpoint PC/mobile) đổi height từng frame qua
    // @include mobile/pc (media query CSS thật, không cần reload) -> tính
    // lại chiều cao track. % dịch chuyển của transform tự bám theo height
    // mới của từng frame nên không cần render() lại.
    window.addEventListener("resize", function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(syncTrackHeight, RESIZE_DEBOUNCE);
    });

    syncTrackHeight();
    renderRest();
  }

  init();
})();
